export default {
  'pages.layouts.userLayout.title':
    'পিঁপড়া ডিজাইন হচ্ছে সিহু জেলার সবচেয়ে প্রভাবশালী ওয়েব ডিজাইনের স্পেসিফিকেশন',
  'pages.login.accountLogin.tab': 'অ্যাকাউন্টে লগইন',
  'pages.login.accountLogin.errorMessage': 'ভুল ব্যবহারকারীর নাম/পাসওয়ার্ড(admin/ant.design)',
  'pages.login.failure': 'লগইন ব্যর্থ হয়েছে। আবার চেষ্টা করুন!',
  'pages.login.success': 'সফল লগইন!',
  'pages.login.username.placeholder': 'ব্যবহারকারীর নাম: admin or user',
  'pages.login.username.required': 'আপনার ব্যবহারকারীর নাম ইনপুট করুন!',
  'pages.login.password.placeholder': 'পাসওয়ার্ড: ant.design',
  'pages.login.password.required': 'আপনার পাসওয়ার্ড ইনপুট করুন!',
  'pages.login.phoneLogin.tab': 'ফোন লগইন',
  'pages.login.phoneLogin.errorMessage': 'যাচাইকরণ কোড ত্রুটি',
  'pages.login.phoneNumber.placeholder': 'ফোন নম্বর',
  'pages.login.phoneNumber.required': 'আপনার ফোন নম্বর ইনপুট করুন!',
  'pages.login.phoneNumber.invalid': 'ফোন নম্বরটি সঠিক নয়!',
  'pages.login.captcha.placeholder': 'যাচাইকরণের কোড',
  'pages.login.captcha.required': 'দয়া করে ভেরিফিকেশন কোডটি ইনপুট করুন!',
  'pages.login.phoneLogin.getVerificationCode': 'কোড পান',
  'pages.getCaptchaSecondText': 'সেকেন্ড',
  'pages.login.rememberMe': 'আমাকে মনে রাখুন',
  'pages.login.forgotPassword': 'পাসওয়ার্ড ভুলে গেছেন?',
  'pages.login.submit': 'প্রবেশ করুন',
  'pages.login.loginWith': 'লগইন করতে পারেন:',
  'pages.login.registerAccount': 'অ্যাকাউন্ট নিবন্ধন করুন',
  'pages.welcome.link': 'স্বাগতম',
  'pages.welcome.alertMessage': 'দ্রুত এবং শক্তিশালী ভারী শুল্ক উপাদান প্রকাশ করা হয়েছে।',
  'pages.404.subTitle': 'দুঃখিত, আপনি যে পৃষ্ঠাটি দেখতে চান তা বিদ্যমান নেই।',
  'pages.404.buttonText': 'প্রধান পাতায় ফিরে যান',
  'pages.admin.subPage.title': 'এই পৃষ্ঠাটি কেবল অ্যাডমিন দ্বারা দেখা যাবে',
  'pages.admin.subPage.alertMessage':
    'UMI UI এখন প্রকাশিত হয়েছে, অভিজ্ঞতা শুরু করতে npm run ui ব্যবহার করতে স্বাগতম।',
  'pages.searchTable.createForm.newRule': 'নতুন বিধি',
  'pages.searchTable.updateForm.ruleConfig': 'বিধি কনফিগারেশন',
  'pages.searchTable.updateForm.basicConfig': 'মৌলিক তথ্য',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'বিধি নাম',
  'pages.searchTable.updateForm.ruleName.nameRules': 'বিধির নাম লিখুন!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'বিধির বিবরণ',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': 'কমপক্ষে পাঁচটি অক্ষর লিখুন',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'কমপক্ষে পাঁচটি অক্ষরের একটি বিধান বিবরণ লিখুন!',
  'pages.searchTable.updateForm.ruleProps.title': 'বৈশিষ্ট্য কনফিগার করুন',
  'pages.searchTable.updateForm.object': 'নিরীক্ষণ অবজেক্ট',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'বিধি টেম্পলেট',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'বিধি প্রকার',
  'pages.searchTable.updateForm.schedulingPeriod.title': 'সময়সূচী নির্ধারণ করুন',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'শুরুর সময়',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': 'একটি শুরুর সময় চয়ন করুন!',
  'pages.searchTable.titleDesc': 'বর্ণনা',
  'pages.searchTable.ruleName': 'বিধি নাম প্রয়োজন',
  'pages.searchTable.titleCallNo': 'পরিষেবা কল সংখ্যা',
  'pages.searchTable.titleStatus': 'অবস্থা',
  'pages.searchTable.nameStatus.default': 'ডিফল্ট',
  'pages.searchTable.nameStatus.running': 'চলমান',
  'pages.searchTable.nameStatus.online': 'অনলাইন',
  'pages.searchTable.nameStatus.abnormal': 'অস্বাভাবিক',
  'pages.searchTable.titleUpdatedAt': 'সর্বশেষ নির্ধারিত',
  'pages.searchTable.exception': 'ব্যতিক্রম জন্য কারণ লিখুন!',
  'pages.searchTable.titleOption': 'অপশন',
  'pages.searchTable.config': 'কনফিগারেশন',
  'pages.searchTable.subscribeAlert': 'সতর্কতা সাবস্ক্রাইব করুন',
  'pages.searchTable.title': 'ইনকয়েরি ফরম',
  'pages.searchTable.new': 'নতুন',
  'pages.searchTable.chosen': 'নির্বাচিত',
  'pages.searchTable.item': 'আইটেম',
  'pages.searchTable.totalServiceCalls': 'পরিষেবা কলগুলির মোট সংখ্যা',
  'pages.searchTable.tenThousand': '000',
  'pages.searchTable.batchDeletion': 'একসাখে ডিলিট',
  'pages.searchTable.batchApproval': 'একসাখে অনুমোদন',

  // Public Holiday Management
  'holidayManagement.title': 'সরকারি ছুটির ব্যবস্থাপনা',
  'holidayManagement.content': 'আপনার সংস্থার জন্য সরকারি ছুটি পরিচালনা করুন',
  'holidayManagement.holidayList': 'ছুটির তালিকা',
  'holidayManagement.addNewHoliday': 'নতুন ছুটি যোগ করুন',
  'holidayManagement.editHoliday': 'ছুটি সম্পাদনা করুন',
  'holidayManagement.addHoliday': 'ছুটি যোগ করুন',
  'holidayManagement.createSuccess': 'ছুটি সফলভাবে তৈরি হয়েছে',
  'holidayManagement.updateSuccess': 'ছুটি সফলভাবে আপডেট হয়েছে',
  'holidayManagement.deleteSuccess': 'ছুটি সফলভাবে মুছে ফেলা হয়েছে',
  'holidayManagement.deleteFailed': 'মুছে ফেলতে ব্যর্থ',
  'holidayManagement.operationFailed': 'অপারেশন ব্যর্থ',
  'holidayManagement.deleteConfirm': 'আপনি কি নিশ্চিত যে আপনি এই ছুটিটি মুছে ফেলতে চান?',
  'holidayManagement.name': 'ছুটির নাম',
  'holidayManagement.description': 'বিবরণ',
  'holidayManagement.date': 'তারিখ',
  'holidayManagement.countryCode': 'দেশ',
  'holidayManagement.stateCode': 'রাজ্য/অঞ্চল',
  'holidayManagement.isNational': 'জাতীয় ছুটি',
  'holidayManagement.status': 'অবস্থা',
  'holidayManagement.action': 'কর্ম',
  'holidayManagement.edit': 'সম্পাদনা করুন',
  'holidayManagement.delete': 'মুছে ফেলুন',
  'holidayManagement.yes': 'হ্যাঁ',
  'holidayManagement.no': 'না',
  'holidayManagement.active': 'সক্রিয়',
  'holidayManagement.inactive': 'নিষ্ক্রিয়',
  'holidayManagement.searchName': 'ছুটির নাম অনুসন্ধান করুন',
  'holidayManagement.searchDescription': 'বিবরণ অনুসন্ধান করুন',
  'holidayManagement.holidayName': 'ছুটির নাম',
  'holidayManagement.pleaseEnterHolidayName': 'অনুগ্রহ করে ছুটির নাম লিখুন',
  'holidayManagement.pleaseSelectDate': 'অনুগ্রহ করে তারিখ নির্বাচন করুন',
  'holidayManagement.pleaseSelectCountry': 'অনুগ্রহ করে দেশ নির্বাচন করুন',
  'holidayManagement.pleaseSelectState': 'অনুগ্রহ করে রাজ্য/অঞ্চল নির্বাচন করুন',
  'holidayManagement.isActive': 'সক্রিয়',
  'holidayManagement.showing': 'দেখাচ্ছে',
  'holidayManagement.of': 'এর',
  'holidayManagement.items': 'আইটেম',

  // হংকংয়ের সরকারি ছুটির নাম
  'holidayManagement.holidayNames.newYearsDay': 'নববর্ষের দিন',
  'holidayManagement.holidayNames.lunarNewYearsDay': 'চান্দ্র নববর্ষের দিন',
  'holidayManagement.holidayNames.secondDayOfLunarNewYear': 'চান্দ্র নববর্ষের দ্বিতীয় দিন',
  'holidayManagement.holidayNames.thirdDayOfLunarNewYear': 'চান্দ্র নববর্ষের তৃতীয় দিন',
  'holidayManagement.holidayNames.chingMingFestival': 'চিং মিং উৎসব',
  'holidayManagement.holidayNames.goodFriday': 'গুড ফ্রাইডে',
  'holidayManagement.holidayNames.dayFollowingGoodFriday': 'গুড ফ্রাইডের পরের দিন',
  'holidayManagement.holidayNames.easterMonday': 'ইস্টার সোমবার',
  'holidayManagement.holidayNames.labourDay': 'শ্রমিক দিবস',
  'holidayManagement.holidayNames.buddhaBirthday': 'বুদ্ধের জন্মদিন',
  'holidayManagement.holidayNames.tuenNgFestival': 'তুয়েন নগ উৎসব',
  'holidayManagement.holidayNames.hkEstablishmentDay': 'হংকং বিশেষ প্রশাসনিক অঞ্চল প্রতিষ্ঠা দিবস',
  'holidayManagement.holidayNames.nationalDay': 'জাতীয় দিবস',
  'holidayManagement.holidayNames.dayFollowingMidAutumn': 'চীনা মধ্য-শরৎ উৎসবের পরের দিন',
  'holidayManagement.holidayNames.chungYeungFestival': 'চুং ইয়াং উৎসব',
  'holidayManagement.holidayNames.christmasDay': 'ক্রিসমাস দিবস',
  'holidayManagement.holidayNames.firstWeekdayAfterChristmas': 'ক্রিসমাসের পর প্রথম কর্মদিবস',
  'holidayManagement.quickAddCommonHoliday': 'সাধারণ ছুটি দ্রুত যোগ করুন',
  'holidayManagement.originalName': 'মূল নাম',
};
